export default __webpack_public_path__ + "static/media/doctor.15b72dae.jpg";